import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createProject, updateProject } from '@/services/projects/projectsApi'
import { backendProjectsQueryKey } from './useBackendProjects.js'

export function useProjectMutations({ onProjectCreated } = {}) {
  const queryClient = useQueryClient()
  const create = useMutation({
    mutationFn: createProject,
    onSuccess: (project) => {
      queryClient.invalidateQueries({ queryKey: backendProjectsQueryKey() })
      if (project) onProjectCreated?.(project)
    },
  })
  const update = useMutation({
    mutationFn: ({ id, patch }) => updateProject(id, patch),
    onMutate: async ({ id, patch }) => {
      const key = backendProjectsQueryKey()
      await queryClient.cancelQueries({ queryKey: key })
      const previous = queryClient.getQueryData(key)
      queryClient.setQueryData(key, (items = []) =>
        items.map((project) =>
          project.id === id ? { ...project, title: patch.name ?? project.title } : project,
        ),
      )
      return { previous, key }
    },
    onError: (_error, _vars, context) => {
      if (context?.key) queryClient.setQueryData(context.key, context?.previous)
    },
    onSettled: (_data, _error, _vars, context) => {
      queryClient.invalidateQueries({ queryKey: context?.key ?? backendProjectsQueryKey() })
    },
  })
  return { createProject: create, updateProject: update }
}
